import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from "@angular/router";

import { SlimScrollOptions, Person } from "app/shared/shared.module";
import { Subscription } from "rxjs/Subscription";
import { PersonService } from "app/person/person.service";

@Component({
	selector: 'app-general-information',
	templateUrl: './general-information.component.html',
	styleUrls: ['./general-information.component.css']
})
export class GeneralInformationComponent implements OnInit {

    Today: Date = new Date();
    PersonId: any;
	Person: Person;

    SlimScrollOptions = SlimScrollOptions;
    sub: Subscription;
    GetPersonDetailsSubscription: Subscription;

    constructor(private personService: PersonService, private route: ActivatedRoute) { }

    ngOnInit() {
        this.sub = this.route.parent.params.subscribe(params => {
            if (params && params['id']) {
                this.PersonId = params['id'];
                this.GetDetails();
            }
        })
    }

    ngOnDestroy() {
        this.sub.unsubscribe();
        if (this.GetPersonDetailsSubscription != null) {
            this.GetPersonDetailsSubscription.unsubscribe();
        }
    }

    GetDetails() {
        this.GetPersonDetailsSubscription = this.personService.GetPersonDetails(this.PersonId).subscribe(
            person => {
                this.Person = person;
            }, err => {
                console.log(err);
            }
        )
    }
}



// WEBPACK FOOTER //
// ./src/app/person/details/general/general-information.component.ts